export default function PageBanner({ title, subtitle }) {
  return (
    <section data-testid="page-banner" className="relative bg-[#B01116] overflow-hidden">
      <div
        className="absolute inset-0 opacity-25"
        style={{
          background:
            "repeating-linear-gradient(135deg, transparent 0px, transparent 60px, rgba(0,0,0,0.12) 60px, rgba(0,0,0,0.12) 120px)",
        }}
        aria-hidden="true"
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20 text-center">
        <h1 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 text-white/85 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
      <div className="relative h-2 bg-[#FFC107]" />
    </section>
  );
}
